import { useDispatch } from "react-redux";
import { openAddRequestInfoModal } from "store/slices/openItem";
import { OpenItemStatus } from "types/Models/openItem";

import { Button } from "components/DesignSystem/Button/Button";

export const RequestedInfoCTA = ({
  customData,
  groupId,
  messageId,
  channelId,
  customText,
}: {
  customData: {
    card_status: OpenItemStatus;
    csv_id: string;
    header: string;
    status: OpenItemStatus;
    transaction_count: 1;
    transaction_ids: string;
  };
  groupId: string;
  messageId: string;
  channelId: string;
  customText?: string;
}) => {
  const dispatch = useDispatch();
  const isRequested = customData.status === "REQUESTED";

  const onAction = () => {
    dispatch(
      openAddRequestInfoModal({
        csvId: customData?.csv_id,
        groupId,
        messageId,
        channelId,
      })
    );
  };

  const urlText = customText || isRequested ? "Add Info" : "View Info";

  return (
    <Button customType="primary" block onClick={onAction} size="small">
      {urlText}
    </Button>
  );
};
